import { o as o_util } from "../chunks/common-namespaces-client-DhfOpdyM.mjs";
import { o as otto } from "../chunks/common-nexus-client-CdICzBNm.mjs";
const onexSync = o_util.onex ?? {};
const isOnexGroup = onexSync.isOnexGroup;
const mapOnexGroup = onexSync.mapOnexGroup;
const withOnex = onexSync.withOnex;
const onexAsync = otto.onex ?? {};
const assignments = onexAsync.assignments;
export {
  assignments,
  isOnexGroup,
  mapOnexGroup,
  onexAsync,
  onexSync,
  withOnex
};
/*                                    */
